(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mei-and-you"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.meilyne-mei__nav');
    if (!button) return;

    var wrapper = button.closest('.meilyne-mei');
    if (!wrapper) return;

    var track = wrapper.querySelector('.meilyne-mei__track');
    if (!track) return;

    var item = track.querySelector('.meilyne-mei__item');
    var amount = item ? item.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;

    track.scrollBy({
      left: button.classList.contains('meilyne-mei__nav--prev') ? -amount : amount,
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-meilyne"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.meilyne-video2__play-button-wrap');
    if (!button) return;

    event.preventDefault();

    var wrapper = button.closest('.meilyne-video2');
    if (!wrapper) return;

    wrapper.classList.add('is-playing');

    var videos = wrapper.querySelectorAll('.meilyne-video2__video');
    videos.forEach(function (video) {
      if (window.getComputedStyle(video).display !== 'none') {
        video.muted = false;
        video.play();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
